import {
  api_url,
  legendLabelsBoxHeightLine,
  configChartsColorPalettes,
  yRight,
  partSumpTrajectory,
  popupInformation,
  defaultDatalabelsAlign,
  defaultDatalabelsAnchor,
  defaultDatalabelsFontWeight,
  defaultTicksCustomValue,
} from "../../../utils";

const VolumeDeplacementsJournaliersMode = {
  checked: false,
  titleSideBar: "Volume de déplacements journaliers par mode - Scénario PMUD",
  titleIndicator: "SUMP Trajectory Content.charts.VolumeDeplacements.title",
  popupInformation: {
    status: "false",
    text: popupInformation[partSumpTrajectory][
      "volumeDeplacementsJournaliersMode"
    ],
  },
  keyFigure: {
    typeUpdate: "geographical_area", // year or geographical_area
    label: "",
    url: "",
    separator: "",
    position: "",
  },

  charts: [
    {
      typeChart: "line",
      typeLabels: "years", // years or geographical_areas
      multiYearGeographicalArea: true,
      singleYearGeographicalAreaType: "year", // year or geographical_area : MUST BE CONSISTENT WITH THE TYPE_LABEL ARGUMENT OF THE DATASET URL
      titleChart: "",
      titleDisplay: "true",
      legendDisplay: "true",
      legendCustom: "false",
      legendLabelsBoxHeight: legendLabelsBoxHeightLine,
      maintainAspectRatio: true,
      indexAxis: "x", // x or y
      heightChart: "300",
      widthChart: "500",
      scales: {
        x: {
          type: "linear",
          display: true,
          stacked: false,
          titleDisplay: false,
          titleText: "",
          gridDisplay: false,
          beginAtZero: false,
          min: 2024,
          max: 2044,
          ticks: {
            display: true,
            value: defaultTicksCustomValue,
          },
        },
        y: {
          type: "linear",
          display: true,
          stacked: true,
          titleDisplay: true,
          titleText: [
            "SUMP Trajectory Content.charts.VolumeDeplacements.axis.titleY",
          ],
          gridDisplay: true,
          beginAtZero: true,
          max: 3000000,
          ticks: {
            display: true,
            value: {
              prefix: "",
              suffix: "",
            },
          },
        },
        yRight: yRight,
      },
      annotationsProperties: {
        annotation1: undefined,
        annotation2: undefined,
      },
      keyFigure: {
        typeUpdate: "geographical_area", // year or geographical_area
        label: "",
        url: "",
        separator: "",
        position: "",
      },
      datasets: [
        {
          type: "line",
          label:
            "SUMP Trajectory Content.charts.VolumeDeplacements.legend.HIDETOOLTIPIFZEROTransporte individual",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=volume_deplacements_journaliers_mode&trend=reality&chart=volume_deplacements_journaliers_mode_transporte_individual&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode"
            ].backgroundColor["0"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode"
            ].borderColor["0"],
          borderWidth: 2,
          pointStyle: "circle",
          pointRadius: 1,
          spanGaps: false,
          legendCustomCssClass: "",
          fill: "stack",
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: 0.9,
          categoryPercentage: 0.6,
          datalabelsProperties: {
            display: false,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "",
            },
          },
        },
        {
          type: "line",
          label:
            "SUMP Trajectory Content.charts.VolumeDeplacements.legend.HIDELEGENDHIDETOOLTIPIFZEROTransporte individual",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=volume_deplacements_journaliers_mode&trend=reality&chart=volume_deplacements_journaliers_mode_transporte_individual_objective&chart_data=True&chart_multi_year_geographical_area=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode_objective_transparency"
            ].backgroundColor["0"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode_objective_transparency"
            ].borderColor["0"],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 1,
          spanGaps: false,
          legendCustomCssClass: "",
          fill: "stack",
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          tooltipToHide: ["2 022"],
          barPercentage: 0.9,
          categoryPercentage: 0.6,
          datalabelsProperties: {
            display: false,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "",
            },
          },
        },
        {
          type: "line",
          label:
            "SUMP Trajectory Content.charts.VolumeDeplacements.legend.HIDETOOLTIPIFZEROTaxi",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=volume_deplacements_journaliers_mode&trend=reality&chart=volume_deplacements_journaliers_mode_taxi&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode"
            ].backgroundColor["1"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode"
            ].borderColor["1"],
          borderWidth: 2,
          pointStyle: "circle",
          pointRadius: 1,
          spanGaps: false,
          legendCustomCssClass: "",
          fill: "stack",
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: 0.9,
          categoryPercentage: 0.6,
          datalabelsProperties: {
            display: false,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "",
            },
          },
        },
        {
          type: "line",
          label:
            "SUMP Trajectory Content.charts.VolumeDeplacements.legend.HIDELEGENDHIDETOOLTIPIFZEROTaxi",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=volume_deplacements_journaliers_mode&trend=reality&chart=volume_deplacements_journaliers_mode_taxi_objective&chart_data=True&chart_multi_year_geographical_area=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode_objective_transparency"
            ].backgroundColor["1"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode_objective_transparency"
            ].borderColor["1"],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 1,
          spanGaps: false,
          legendCustomCssClass: "",
          fill: "stack",
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          tooltipToHide: ["2 022"],
          barPercentage: 0.9,
          categoryPercentage: 0.6,
          datalabelsProperties: {
            display: false,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "",
            },
          },
        },
        {
          type: "line",
          label:
            "SUMP Trajectory Content.charts.VolumeDeplacements.legend.HIDETOOLTIPIFZEROMoto-Taxi",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=volume_deplacements_journaliers_mode&trend=reality&chart=volume_deplacements_journaliers_mode_moto_taxi&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode"
            ].backgroundColor["2"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode"
            ].borderColor["2"],
          borderWidth: 2,
          pointStyle: "circle",
          pointRadius: 1,
          spanGaps: false,
          legendCustomCssClass: "",
          fill: "stack",
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: 0.9,
          categoryPercentage: 0.6,
          datalabelsProperties: {
            display: false,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "",
            },
          },
        },
        {
          type: "line",
          label:
            "SUMP Trajectory Content.charts.VolumeDeplacements.legend.HIDELEGENDHIDETOOLTIPIFZEROMoto-Taxi",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=volume_deplacements_journaliers_mode&trend=reality&chart=volume_deplacements_journaliers_mode_moto_taxi_objective&chart_data=True&chart_multi_year_geographical_area=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode_objective_transparency"
            ].backgroundColor["2"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode_objective_transparency"
            ].borderColor["2"],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 1,
          spanGaps: false,
          legendCustomCssClass: "",
          fill: "stack",
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          tooltipToHide: ["2 022"],
          barPercentage: 0.9,
          categoryPercentage: 0.6,
          datalabelsProperties: {
            display: false,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "",
            },
          },
        },
        {
          type: "line",
          label:
            "SUMP Trajectory Content.charts.VolumeDeplacements.legend.HIDETOOLTIPIFZEROBRT",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=volume_deplacements_journaliers_mode&trend=reality&chart=volume_deplacements_journaliers_mode_brt&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode"
            ].backgroundColor["3"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode"
            ].borderColor["3"],
          borderWidth: 2,
          pointStyle: "circle",
          pointRadius: 1,
          spanGaps: false,
          legendCustomCssClass: "",
          fill: "stack",
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: 0.9,
          categoryPercentage: 0.6,
          datalabelsProperties: {
            display: false,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "",
            },
          },
        },
        {
          type: "line",
          label:
            "SUMP Trajectory Content.charts.VolumeDeplacements.legend.HIDELEGENDHIDETOOLTIPIFZEROBRT",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=volume_deplacements_journaliers_mode&trend=reality&chart=volume_deplacements_journaliers_mode_brt_objective&chart_data=True&chart_multi_year_geographical_area=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode_objective_transparency"
            ].backgroundColor["3"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode_objective_transparency"
            ].borderColor["3"],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 1,
          spanGaps: false,
          legendCustomCssClass: "",
          fill: "stack",
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          tooltipToHide: ["2 022"],
          barPercentage: 0.9,
          categoryPercentage: 0.6,
          datalabelsProperties: {
            display: false,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "",
            },
          },
        },
        {
          type: "line",
          label:
            "SUMP Trajectory Content.charts.VolumeDeplacements.legend.HIDETOOLTIPIFZEROBus",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=volume_deplacements_journaliers_mode&trend=reality&chart=volume_deplacements_journaliers_mode_bus&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode"
            ].backgroundColor["4"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode"
            ].borderColor["4"],
          borderWidth: 2,
          pointStyle: "circle",
          pointRadius: 1,
          spanGaps: false,
          legendCustomCssClass: "",
          fill: "stack",
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: 0.9,
          categoryPercentage: 0.6,
          datalabelsProperties: {
            display: false,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "",
            },
          },
        },
        {
          type: "line",
          label:
            "SUMP Trajectory Content.charts.VolumeDeplacements.legend.HIDELEGENDHIDETOOLTIPIFZEROBus",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=volume_deplacements_journaliers_mode&trend=reality&chart=volume_deplacements_journaliers_mode_bus_objective&chart_data=True&chart_multi_year_geographical_area=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode_objective_transparency"
            ].backgroundColor["4"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode_objective_transparency"
            ].borderColor["4"],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 1,
          spanGaps: false,
          legendCustomCssClass: "",
          fill: "stack",
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          tooltipToHide: ["2 022"],
          barPercentage: 0.9,
          categoryPercentage: 0.6,
          datalabelsProperties: {
            display: false,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "",
            },
          },
        },
        {
          type: "line",
          label:
            "SUMP Trajectory Content.charts.VolumeDeplacements.legend.HIDETOOLTIPIFZEROColectivo",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=volume_deplacements_journaliers_mode&trend=reality&chart=volume_deplacements_journaliers_mode_colectivo&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode"
            ].backgroundColor["5"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode"
            ].borderColor["5"],
          borderWidth: 2,
          pointStyle: "circle",
          pointRadius: 1,
          spanGaps: false,
          legendCustomCssClass: "",
          fill: "stack",
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: 0.9,
          categoryPercentage: 0.6,
          datalabelsProperties: {
            display: false,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "",
            },
          },
        },
        {
          type: "line",
          label:
            "SUMP Trajectory Content.charts.VolumeDeplacements.legend.HIDELEGENDHIDETOOLTIPIFZEROColectivo",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=volume_deplacements_journaliers_mode&trend=reality&chart=volume_deplacements_journaliers_mode_colectivo_objective&chart_data=True&chart_multi_year_geographical_area=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode_objective_transparency"
            ].backgroundColor["5"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode_objective_transparency"
            ].borderColor["5"],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 1,
          spanGaps: false,
          legendCustomCssClass: "",
          fill: "stack",
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          tooltipToHide: ["2 022"],
          barPercentage: 0.9,
          categoryPercentage: 0.6,
          datalabelsProperties: {
            display: false,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "",
            },
          },
        },
        {
          type: "line",
          label:
            "SUMP Trajectory Content.charts.VolumeDeplacements.legend.HIDETOOLTIPIFZEROBicyclette",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=volume_deplacements_journaliers_mode&trend=reality&chart=volume_deplacements_journaliers_mode_bicyclette&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode"
            ].backgroundColor["6"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode"
            ].borderColor["6"],
          borderWidth: 2,
          pointStyle: "circle",
          pointRadius: 1,
          spanGaps: false,
          legendCustomCssClass: "",
          fill: "stack",
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: 0.9,
          categoryPercentage: 0.6,
          datalabelsProperties: {
            display: false,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "",
            },
          },
        },
        {
          type: "line",
          label:
            "SUMP Trajectory Content.charts.VolumeDeplacements.legend.HIDELEGENDHIDETOOLTIPIFZEROBicyclette",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=volume_deplacements_journaliers_mode&trend=reality&chart=volume_deplacements_journaliers_mode_bicyclette_objective&chart_data=True&chart_multi_year_geographical_area=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode_objective_transparency"
            ].backgroundColor["6"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode_objective_transparency"
            ].borderColor["6"],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 1,
          spanGaps: false,
          legendCustomCssClass: "",
          fill: "stack",
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          tooltipToHide: ["2 022"],
          barPercentage: 0.9,
          categoryPercentage: 0.6,
          datalabelsProperties: {
            display: false,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "",
            },
          },
        },
        {
          type: "line",
          label:
            "SUMP Trajectory Content.charts.VolumeDeplacements.legend.HIDETOOLTIPIFZEROMarche à pied",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=volume_deplacements_journaliers_mode&trend=reality&chart=volume_deplacements_journaliers_mode_marche&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode"
            ].backgroundColor["7"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode"
            ].borderColor["7"],
          borderWidth: 2,
          pointStyle: "circle",
          pointRadius: 1,
          spanGaps: false,
          legendCustomCssClass: "",
          fill: "stack",
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: 0.9,
          categoryPercentage: 0.6,
          datalabelsProperties: {
            display: false,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "",
            },
          },
        },
        {
          type: "line",
          label:
            "SUMP Trajectory Content.charts.VolumeDeplacements.legend.HIDELEGENDHIDETOOLTIPIFZEROMarche à pied",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=volume_deplacements_journaliers_mode&trend=reality&chart=volume_deplacements_journaliers_mode_marche_objective&chart_data=True&chart_multi_year_geographical_area=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode_objective_transparency"
            ].backgroundColor["7"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode_objective_transparency"
            ].borderColor["7"],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 1,
          spanGaps: false,
          legendCustomCssClass: "",
          fill: "stack",
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          tooltipToHide: ["2 022"],
          barPercentage: 0.9,
          categoryPercentage: 0.6,
          datalabelsProperties: {
            display: false,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "",
            },
          },
        },
        {
          type: "line",
          label:
            "SUMP Trajectory Content.charts.VolumeDeplacements.legend.HIDETOOLTIPIFZEROOtros",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=volume_deplacements_journaliers_mode&trend=reality&chart=volume_deplacements_journaliers_mode_otros&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode"
            ].backgroundColor["8"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode"
            ].borderColor["8"],
          borderWidth: 2,
          pointStyle: "circle",
          pointRadius: 1,
          spanGaps: false,
          legendCustomCssClass: "",
          fill: "stack",
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: 0.9,
          categoryPercentage: 0.6,
          datalabelsProperties: {
            display: false,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "",
            },
          },
        },
        {
          type: "line",
          label:
            "SUMP Trajectory Content.charts.VolumeDeplacements.legend.HIDELEGENDHIDETOOLTIPIFZEROOtros",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=volume_deplacements_journaliers_mode&trend=reality&chart=volume_deplacements_journaliers_mode_otros_objective&chart_data=True&chart_multi_year_geographical_area=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode_objective_transparency"
            ].backgroundColor["8"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_volume_deplacements_journaliers_mode_objective_transparency"
            ].borderColor["8"],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 1,
          spanGaps: false,
          legendCustomCssClass: "",
          fill: "stack",
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          tooltipToHide: ["2 022"],
          barPercentage: 0.9,
          categoryPercentage: 0.6,
          datalabelsProperties: {
            display: false,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "",
            },
          },
        },
      ],
    },
  ],
};

export default VolumeDeplacementsJournaliersMode;
